import {
  Formik,
  Field,
} from 'formik';
import {
  DateTime,
} from 'luxon';

import {
  Select,
  Button,
  DatePickerField,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';

const selectProps = {
  styles: {
    container: provided => ({
      ...provided,
      width: '100%',
    }),
    menu: provided => ({
      ...provided,
      marginTop: '1px',
    }),
  },
  theme: theme => ({
    ...theme,
    borderRadius: 3,
  }),
};

type Props = {
  clientId: string,
  startDate: Date,
  workoutsOptions: any,
  onSubmit: { (values: any): void },
  onCancel: { (): void },
};

const ScheduleWorkout = ({
  onSubmit,
  workoutsOptions,
  startDate,
  onCancel,
  clientId,
}: Props) => (
  <Formik
    initialValues={{
      client: clientId,
      start: DateTime.fromJSDate(startDate),
      end: DateTime.fromJSDate(startDate).plus({ hours: 1 }),
    }}
    onSubmit={onSubmit}
    enableReinitialize
  >
    {(formikProps) => (
      <Flex
        column
        as="form"
        width="100%"
        onSubmit={formikProps.handleSubmit}
      >
        <Flex width="100%" column>
          <S.Label>
            Time
          </S.Label>
          <Flex spacing={10}>
            <Field
              name="start"
              dateFormat="MM/dd/yyyy   hh:mm a"
              showTimeSelect
              component={DatePickerField}
            />
            <Field
              name="end"
              dateFormat="MM/dd/yyyy   hh:mm a"
              showTimeSelect
              popperPlacement="bottom-end"
              component={DatePickerField}
            />
          </Flex>
        </Flex>
        <Flex width="100%" column>
          <S.Label htmlFor="workout-select">
            Workout
          </S.Label>
          <Select
            {...selectProps}
            id="workout-select"
            value={workoutsOptions ? workoutsOptions.find(option => option.value === formikProps.values.workout) || '' : ''}
            onChange={(option: typeof Option) => formikProps.setFieldValue('workout', option.value)}
            onBlur={formikProps.handleBlur}
            name="workout"
            options={workoutsOptions}
          />
        </Flex>
        <S.Footer>
          <hr />
          <Flex
            width="100%"
            justify="space-between"
          >
            <Button
              ghost
              appearance="danger"
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              appearance="primary"
              isDisabled={
                  !formikProps.values.start
                  || !formikProps.values.end
                  || !formikProps.values.workout
                }
            >
              Schedule
            </Button>
          </Flex>
        </S.Footer>
      </Flex>
    )}
  </Formik>
);

export default ScheduleWorkout;
